const PATHS = {
  star: "M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z",
  pencil: "M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4",
  download: "M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 19h14",
  trash: "M4 7h16M9 7V4h6v3m-8 0l1 13h8l1-13",
  close: "M6 6l12 12M18 6L6 18",
  left: "M15 5l-7 7 7 7",
  right: "M9 5l7 7-7 7",
  doc: "M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6",
  upload: "M12 16V5m0 0L7.5 9.5M12 5l4.5 4.5M5 19h14",
};
export function Icon({ name, size = 16, filled = false }) {
  return <svg aria-hidden="true" focusable="false" width={size} height={size} viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d={PATHS[name]} /></svg>;
}
